import React from 'react';
import './PricingCard.css';
import { CheckMark2 } from '../../assets';
import { pricing_plans } from '../../constants';

const PricingCard = (props) => {
  return (
    <div className='pricing_card' onClick={() => window.location.href = '/register'}>
      <h1 className='pricing_card_name'>{pricing_plans[props.plan].name}</h1>
      <p className='pricing_card_title'>{pricing_plans[props.plan].subtitle}</p>
      <div className='pricing_divider' style={{top: '20px'}} />
      <div className='pricing_price'><span>$</span><h1>{pricing_plans[props.plan][props.yearly ? 'year' : 'month']}</h1><p>/ Month</p></div>
      <div className='pricing_divider' style={{top: '80px'}} />
      <div className='pricing_props'>
      {pricing_plans[props.plan].data.map((plan) => (
        <div className='pricing_props_item'>
            <CheckMark2 style={{position: 'relative', width: '30px', height: '30px'}}/>
            <p>{plan}</p>
        </div>
      ))}
      </div>
    </div>
  )
}

export default PricingCard
